/**
 * Check if the device is iOS
 * @returns {boolean} true si l'appareil est iOS (iPad, iPhone, iPod)
 */
export const _isIOS = () => {
  if (typeof navigator === 'undefined')
    return false;

  const ua = navigator.userAgent || '';
  const platform = navigator.platform || '';
  const maxTouchPoints = navigator.maxTouchPoints || 0;

  // Classic iPhone / iPad / iPod
  if (/iPad|iPhone|iPod/.test(ua))
    return true;

  // iPadOS pretending to be a Mac
  const isMacLike = /Macintosh/.test(ua) || /MacIntel/.test(platform);

  // Very likely an iPad
  if (isMacLike && maxTouchPoints > 1)
    return true;

  return false;
};

// Only gps-app injects this flag.
export const isInGpsApp = () => window.IS_NATIVE_WEBVIEW === true;

/**
 * Check if the application is in an iOS WebView
 * @returns {boolean} true if the app is in an iOS WebView (not Safari)
 */
export const isInWebView = () => {
  // We try to systematically inject a window property in our iOS apps
  // otherwise we fallback to the classic user agent detection
  if (isInGpsApp())
    return true;

  if (typeof navigator === 'undefined')
    return false;

  return _isIOS() && !/Safari/.test(navigator.userAgent || '');
};

// Any native app: gps-app, or a L'Oréal shell, which only exposes the bridge.
export const isInNativeApp = () => isInWebView() || Boolean(window.ReactNativeWebView);

/** @returns {'ios' | 'android' | 'desktop'} */
export const devicePlatform = () => {
  if (_isIOS()) return 'ios';
  return /Android/i.test(navigator.userAgent || '') ? 'android' : 'desktop';
};

/**
 * Not `isInNativeApp()`: an iOS home-screen web app or in-app browser is still 'web'.
 * @returns {'gps_app' | 'shell' | 'web'}
 */
export const connectionClient = () => {
  if (isInGpsApp()) return 'gps_app';
  return window.ReactNativeWebView ? 'shell' : 'web';
};

/**
 * Check if the application is embedded in an iframe
 * @returns {boolean} true if the app runs inside an iframe
 */
export const isInIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    // A cross-origin parent throws on window.top access, which only happens in an iframe
    return true;
  }
};